export default __webpack_public_path__ + "a2fc80235786dcb0da416fee9d03861d.svg";